import { TriangleAlert } from "lucide-react";

const BLOCK_NOUNS: Record<string, string> = {
  rate_comparison: "rate comparison",
  action_proposal: "action",
  plan: "plan",
  chart: "chart",
  guidance: "guidance",
  dashboard_card: "dashboard",
  feed_snapshot: "feed",
  schedule_snapshot: "schedule",
  scheduled_reports_snapshot: "scheduled reports",
};

/**
 * Terminal fallback for a structured fence block whose JSON failed to parse
 * once streaming has finished. Shows a short, friendly note instead of leaking
 * the raw JSON body into the chat.
 */
export function KaiBlockError({ tag }: { tag?: string }) {
  const noun = (tag && BLOCK_NOUNS[tag]) || "content";
  return (
    <div className="my-2 flex items-center gap-1.5 text-xs text-muted-foreground">
      <TriangleAlert className="size-3.5 shrink-0 text-amber-500" />
      This {noun} couldn't be displayed.
    </div>
  );
}
